import { useCallback, useEffect, useState } from 'react';

export function useBuySellFullscreen(rootRef) {
  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const syncFullscreen = () => {
      const el = rootRef.current;
      const active =
        document.fullscreenElement === el ||
        document.webkitFullscreenElement === el;
      setIsFullscreen(Boolean(active));
    };

    document.addEventListener('fullscreenchange', syncFullscreen);
    document.addEventListener('webkitfullscreenchange', syncFullscreen);
    syncFullscreen();
    return () => {
      document.removeEventListener('fullscreenchange', syncFullscreen);
      document.removeEventListener('webkitfullscreenchange', syncFullscreen);
    };
  }, [rootRef]);

  return isFullscreen;
}

export function useSectionRef(sectionRef, rootRef) {
  return useCallback(
    (node) => {
      rootRef.current = node;
      if (typeof sectionRef === 'function') {
        sectionRef(node);
      } else if (sectionRef) {
        sectionRef.current = node;
      }
    },
    [sectionRef, rootRef],
  );
}

export default useBuySellFullscreen;
